import { requester } from '../utils';

export const fetchAllDiscountCodes = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/discount-code?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchDiscountCodeById = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/discount-code/${id}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const insertNewDiscountCode = discountCodeObject => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/discount-code`,
        method: 'POST',
        withAuth: true,
        data: discountCodeObject
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const updateDiscountCode = discountCodeObject => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/discount-code`,
        method: 'PUT',
        withAuth: true,
        data: discountCodeObject
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const updateDiscountCodeStatus = (id, status) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/discount-code/status`,
        method: 'PUT',
        withAuth: true,
        data: {
          id,
          status
        }
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const createRandomCode = () => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/general/random`,
        method: 'POST',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchSearchedSpecialUsers = searchKey => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/user/activated?${searchKey}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchAllDiscountCodeUsers = (id, query) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/discount-code/users/${id}?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
